import { useUISettingsContext } from "../context/UISettingsContext";

export function useUISettings() {
  return useUISettingsContext();
}
